// extracted by mini-css-extract-plugin
export default {"button":"StickyToggle_button__pANb1","wrapper":"StickyToggle_wrapper__l1cla"};